function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.9 19a3.824 3.824 0 00-2.7-2.8c-.1 0-.2-.1-.2-.3V8c0-.1 0-.2.2-.2.1 0 .2-.1.3-.1A3.924 3.924 0 0016 4a3.927 3.927 0 00-3.9-4 4.089 4.089 0 00-3.8 5.5 3.819 3.819 0 002.5 2.3c.1 0 .2.1.2.3V16c0 .1 0 .2-.2.2s-.3.1-.5.2A3.862 3.862 0 008 19.6a3.398 3.398 0 00.3 2 3.978 3.978 0 002.6 2.3 3.854 3.854 0 002.6-.2 3.895 3.895 0 002.3-2.7 3.378 3.378 0 00.1-2zm-4-12.9a2.2 2.2 0 112.2-2.2 2.098 2.098 0 01-2.2 2.2z"
});

function SvgSpCiMaster(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default __webpack_public_path__ + "spCIMaster.4d6a9.svg";
export { SvgSpCiMaster as ReactComponent };